const defaultItem = {
	fitType: '',
	selectedFitType: null,
	note: '',
	creditCardRecord: 0,
	selectedCreditCardCurrency: {
		value: 'THB',
		label: 'ไทย (บาท)',
	},
	selectedCreditCard: null,
	price: 0,
	creditCharge: 0,
};

const defaultFITDetail = {
	fitTicket: {
		route: '',
		airlineId: 0,
		airline: null,
		selectedAirline: null,
		flightNumber: '',
		pnr: '',
		passengers: [
			{
				name: '',
				ticketNumber: '',
				price: 0,
				salePrice: 0,
			},
		],
	},
	fitVisa: {
		details: [
			{
				title: 'ค่าธรรมเนียมสถานทูต',
				price: 0,
				salePrice: 0,
			},
			{
				title: 'ค่าบริการยื่น VISA',
				price: 0,
				salePrice: 0,
			},
			{
				title: 'ค่าธรรมเนียมศูนย์ยื่น',
				price: 0,
				salePrice: 0,
			},
		],
	},
	fitHotel: {
		details: [
			{
				title: '',
				price: 0,
				salePrice: 0,
			},
		],
	},
	fitCarRental: {
		details: [
			{
				title: '',
				price: 0,
				salePrice: 0,
			},
		],
	},
	fitInsurrance: {
		details: [
			{
				title: '',
				price: 0,
				salePrice: 0,
			},
		],
	},
	fitTravelTicket: {
		details: [
			{
				title: '',
				price: 0,
				salePrice: 0,
			},
		],
	},
	fitPocketWifiSim: {
		details: [
			{
				title: '',
				price: 0,
				salePrice: 0,
			},
		],
	},
	fitTranslation: {
		details: [
			{
				title: '',
				price: 0,
				salePrice: 0,
			},
		],
	},
};

const createFITItemHelper = function(newState) {
	if (!newState) newState = [];
	let state = [];
	if (newState.length === 0) {
		state = JSON.parse(
			JSON.stringify([
				{
					...defaultItem,
				},
			])
		);
	} else {
		state = JSON.parse(JSON.stringify(newState));
	}

	return (function() {
		const resetState = newState => {
			state = JSON.parse(JSON.stringify(newState));
		};

		const onChange = (index, key, value) => {
			// console.log(index, key, value);
			state[index][key] = value;
			if (key === 'selectedFitType' && value) {
				const fitType = value.value;
				state[index].fitType = fitType;
				if (!state[index][fitType]) {
					state[index][fitType] = JSON.parse(JSON.stringify(defaultFITDetail[fitType]));
				}

				state[index].selectedSupplier = null;
			} else if (key === 'creditCharge') {
				const itemPrice = getItemPrice(state[index]);
				state[index].creditCardRecord = itemPrice.salePrice + itemPrice.creditCharge;
			}

			return state;
		};

		const onDetailChange = (parentIndex, key, value) => {
			const fitType = state[parentIndex].fitType;
			state[parentIndex][fitType][key] = value;

			return state;
		};

		const onDetailArrayChange = (parentIndex, index, key, value) => {
			const fitType = state[parentIndex].fitType;
			if (fitType === 'fitTicket') {
				state[parentIndex][fitType].passengers[index][key] = value;
			} else {
				state[parentIndex][fitType].details[index][key] = value;
			}

			return state;
		};

		const getState = () => {
			return state;
		};

		const addRow = () => {
			state = [...state, { ...defaultItem, id: 'new' + state.length }];
			return state;
		};

		const removeRow = index => {
			state.splice(index, 1);
			return state;
		};

		const addDetail = parentIndex => {
			const fitType = state[parentIndex].fitType;
			if (fitType === 'fitTicket') {
				state[parentIndex][fitType].passengers.push({ ...defaultFITDetail[fitType].passengers[0] });
			} else if (fitType === 'fitVisa') {
				state[parentIndex][fitType].details.push({
					title: '',
					pricePerPiece: 0,
					salePricePerPiece: 0,
					price: 0,
					salePrice: 0,
				});
			} else {
				state[parentIndex][fitType].details.push({
					...defaultFITDetail[fitType].details[0],
				});
			}
			console.log(state);
			return state;
		};

		const removeDetail = (parentIndex, index) => {
			const fitType = state[parentIndex].fitType;
			if (fitType === 'fitTicket') {
				state[parentIndex][fitType].passengers.splice(index, 1);
			} else {
				state[parentIndex][fitType].details.splice(index, 1);
			}

			return state;
		};

		const getItemPrice = item => {
			const toNumber = value => {
				const parsed = parseFloat(value);
				return Number.isFinite(parsed) ? parsed : 0;
			};

			let itemPrice = { salePrice: 0, creditCharge: 0, price: 0 };
			if (!item || !item.fitType || !item[item.fitType]) {
				return itemPrice;
			}

			if (item.fitType === 'fitTicket') {
				const passengers = item.fitTicket && Array.isArray(item.fitTicket.passengers) ? item.fitTicket.passengers : [];
				passengers.forEach(passenger => {
					const salePrice = toNumber(passenger.salePrice);
					itemPrice.salePrice += salePrice;
					itemPrice.creditCharge += toNumber((toNumber(item.creditCharge) * salePrice) / 100);
					itemPrice.price += toNumber(passenger.price);
				});
			} else if (item.fitType === 'fitVisa') {
				const details = Array.isArray(item[item.fitType].details) ? item[item.fitType].details : [];
				const amount = toNumber(item[item.fitType].amount);
				details.forEach(detail => {
					const salePrice = amount * toNumber(detail.salePricePerPiece);
					const price = amount * toNumber(detail.pricePerPiece);
					itemPrice.salePrice += salePrice;
					itemPrice.creditCharge += toNumber((toNumber(item.creditCharge) * salePrice) / 100);
					itemPrice.price += price;
				});
			} else {
				const details = Array.isArray(item[item.fitType].details) ? item[item.fitType].details : [];
				details.forEach(detail => {
					const salePrice = toNumber(detail.salePrice);
					itemPrice.salePrice += salePrice;
					itemPrice.creditCharge += toNumber((toNumber(item.creditCharge) * salePrice) / 100);
					itemPrice.price += toNumber(detail.price);
				});
			}

			return itemPrice;
		};

		const getTotalPrice = () => {
			let totalPrice = { salePrice: 0, creditCharge: 0, price: 0 };
			state.forEach(item => {
				const itemPrice = getItemPrice(item);
				totalPrice.salePrice += itemPrice.salePrice;
				totalPrice.creditCharge += itemPrice.creditCharge;
				totalPrice.price += itemPrice.price;
			});

			return totalPrice;
		};

		const isTicket = item => {
			return item.fitType === 'fitTicket' && item.fitTicket && item.fitTicket.passengers && item.fitTicket.passengers.length > 0;
		};

		const isVisa = item => {
			return item.fitType === 'fitVisa' && item.fitVisa && item.fitVisa.details.length > 0;
		};

		const validateItem = item => {
			// console.log(`validateItem: `, item);
			if (item.fitType === '') {
				console.log(`fitType is empty`);
				return false;
			}

			if (item.creditCardRecord > 0 && !item.selectedCreditCard) {
				console.log(`creditCardRecord is greater than 0 and selectedCreditCard is empty`);
				console.log(`item.creditCardRecord: `, item.creditCardRecord);
				console.log(`item.selectedCreditCard: `, item.selectedCreditCard);
				return false;
			}

			if (item.selectedCreditCard && !item.selectedCreditCardCurrency) {
				if (item.se) console.log(`selectedCreditCard is not empty and selectedCreditCardCurrency is empty`);
				console.log(`selectedCreditCard: `, item.selectedCreditCard);
				console.log(`selectedCreditCardCurrency: `, item.selectedCreditCardCurrency);
				return false;
			}

			if (!item.selectedSupplier) {
				console.log(`selectedSupplier is empty`);
				return false;
			} else if (item.selectedSupplier && item.selectedSupplier.value === '') {
				console.log(`selectedSupplier value was empty`);
				return false;
			}

			if (isTicket(item)) {
				// console.log(`isTicket is true`);
				return validateFitTicket(item);
			} else if (isVisa(item)) {
				// console.log(`isVisa is true`);
				return validateFitVisa(item);
			}

			return true;
		};

		const validateFitTicket = item => {
			if (item.fitTicket) {
				const { fitTicket } = item;
				if (!fitTicket.selectedAirline) {
					console.log(`selectedAirline is empty`);
					return false;
				}

				if (fitTicket.flightNumber.trim() === '') {
					console.log(`flightNumber is empty`);
					return false;
				}

				if (fitTicket.pnr.trim() === '') {
					console.log(`pnr is empty`);
					return false;
				}

				if (fitTicket.route.trim() === '') {
					console.log(`route is empty`);
					return false;
				}

				if (
					fitTicket.passengers.filter(passenger => {
						const name = (passenger && passenger.name) || '';
						const ticketNumber = (passenger && passenger.ticketNumber) || '';
						const result = name.trim() === '' || ticketNumber.trim() === '';
						if (result) {
							console.log(`passenger: `, passenger);
							console.log(`name: `, name);
							console.log(`ticketNumber: `, ticketNumber);
							console.log(`name or ticket was empty`);
						}

						return result;
					}).length > 0
				) {
					return false;
				}
			} else {
				console.log(`not fit ticker`);
				return false;
			}

			return true;
		};

		const validateFitVisa = item => {
			if (item.fitVisa) {
				const { details } = item.fitVisa;
				if (details.length === 0) {
					return false;
				}

				if (details.filter(visa => visa.title.trim() === '').length > 0) {
					console.log(`visa title is empty`);
					return false;
				}
			} else {
				console.log(`not fit visa`);
				return false;
			}

			return true;
		};

		const getDataForCreateOrUpdateAPI = () => {
			let result = [];

			state.forEach(item => {
				const { price, salePrice, totalPrice, totalSalePrice } = getItemPrice(item);
				let rowItem = {
					...item,
					price,
					salePrice,
					totalPrice,
					totalSalePrice,
					supplierId: item.selectedSupplier ? item.selectedSupplier.value : null,
					creditCardId: item.selectedCreditCard ? item.selectedCreditCard.value : null,
					creditCardCurrency: item.selectedCreditCardCurrency ? item.selectedCreditCardCurrency.value : '',
					visaType: item.selectedVisaType ? item.selectedVisaType.value : null,
					countryId: item.selectedCountry ? item.selectedCountry.value : null,
				};

				if (isTicket(item)) {
					rowItem.fitTicket.airlineId = item.fitTicket && item.fitTicket.selectedAirline ? item.fitTicket.selectedAirline.value : null;
				}

				result.push(rowItem);
			});

			return result;
		};

		const validateTraveler = item => {
			if (item.fitTicket) {
				const { passengers } = item.fitTicket;
				// Check for duplicate traveler IDs in passengers (supports both traveler.id and travelerId)
				if (Array.isArray(passengers)) {
					const travelerIds = [];
					for (const passenger of passengers) {
						if (passenger.travelerId) {
							travelerIds.push(passenger.travelerId);
						}
					}

					if (travelerIds.length !== new Set(travelerIds).size) {
						console.log('Duplicate fit ticket found: ', travelerIds);
						return false; // Duplicate found
					}
				}
			}

			return true;
			// "fitTicket":   "passengers":[{
			// "travelerId": 2,
			// "ticketNumber":"123fttt",
			// "price":"3500",
			// "salePrice":"5000"
			// }],
			// "fitVisa": {
			// 		"details": [
			// 				{
			// 						"id": 1319,
			// 						"fitVisaId": 957,
			// 						"title": "XXX 3 BLS",
			// 						"price": 885,
			// 						"salePrice": 1000
			// 				}
			// 		],
			// 		"travelerIds": [2,3]
			// },
		};

		return {
			resetState,
			getState,
			onChange,
			onDetailChange,
			onDetailArrayChange,
			addRow,
			removeRow,
			addDetail,
			removeDetail,
			getItemPrice,
			getTotalPrice,
			isTicket,
			isVisa,
			validateItem,
			getDataForCreateOrUpdateAPI,
		};
	})();
};

export default createFITItemHelper;
